import { render, staticRenderFns } from "./billingPriceComponent.vue?vue&type=template&id=bf10b2e0&scoped=true"
import script from "./billingPriceComponent.vue?vue&type=script&lang=js"
export * from "./billingPriceComponent.vue?vue&type=script&lang=js"
import style0 from "./billingPriceComponent.vue?vue&type=style&index=0&id=bf10b2e0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf10b2e0",
  null
  
)

export default component.exports